import { type HTMLAttributes } from 'react';

type Status = 'online' | 'offline' | 'degraded' | 'critical';
type DotSize = 'sm' | 'md' | 'lg';

interface StatusDotProps extends HTMLAttributes<HTMLSpanElement> {
  status: Status;
  size?: DotSize;
}

const STATUS_COLORS: Record<Status, string> = {
  online: 'bg-status-online',
  offline: 'bg-status-offline',
  degraded: 'bg-status-degraded',
  critical: 'bg-status-critical',
};

const SIZE_CLASSES: Record<DotSize, string> = {
  sm: 'w-2 h-2',
  md: 'w-2.5 h-2.5',
  lg: 'w-3 h-3',
};

export function StatusDot({ status, size = 'md', className = '', ...props }: StatusDotProps) {
  return (
    <span
      className={`inline-block rounded-full ${STATUS_COLORS[status]} ${SIZE_CLASSES[size]} ${className}`}
      title={status}
      {...props}
    />
  );
}
